module.exports = __webpack_public_path__ + "img/width-narrow@2x.b305503.jpg";